import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'difficulty',
  standalone: true,
})
export class DifficultyPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return 'Não definida';
    }

    switch (value.toUpperCase()) {
      case 'F':
        return 'Fácil';
      case 'M':
        return 'Médio';
      case 'D':
        return 'Difícil';
      default:
        return value;
    }
  }
}
